import { render, staticRenderFns } from "./VgcProductPikcer.vue?vue&type=template&id=66ecd178&scoped=true"
import script from "./VgcProductPikcer.vue?vue&type=script&lang=js"
export * from "./VgcProductPikcer.vue?vue&type=script&lang=js"
import style0 from "./VgcProductPikcer.vue?vue&type=style&index=0&id=66ecd178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ecd178",
  null
  
)

export default component.exports